import * as React from 'react'

const useProgress = () => {
    const [ questionnaires, setQuestionnaires ] = React.useState([])

    const register = React.useCallback((questionnaireId) => {
        setQuestionnaires((prev) => {
            const questionniare = prev.find(q => q.id === questionnaireId)
            if( !questionniare ) {
                return [
                    ...prev,
                    { id: questionnaireId, tabs: [] }
                ]
            }

            return prev
        })
    }, [])

    return {
        control: {
            progressQuestionnaires: questionnaires,
            progressUpdateCurrentState: (questionnaireId, tabs) => {
                setQuestionnaires((prev) => {
                    const questionnaire = prev.find(q => q.id === questionnaireId)
                    if( !questionnaire ) {
                        return prev
                    }

                    return prev.map(q => {
                        if( q.id === questionnaireId ) {
                            return { ...q, tabs }
                        }

                        return q
                    })
                })
            }
        },
        register: register
    }
}

export {
    useProgress
}
